import JwtUtils from "../../utils/jwtUtils";
import authorizationStore from "../../auth/authorizationStore";
import { UserRoles } from "../../enums";
import { ODIN_EVENT_EDITION_STORAGE_KEY } from "../../constants";
import EventsHelper from "../../badges/events/EventsHelper";
import { MercuryEvents } from "../../../services/types";

class JWTHelper {
  private primaryUserRole: UserRoles = UserRoles.CUSTOMER_SERVICES_AGENT;
  private _secondaryUserRoles: UserRoles[] = [];

  get secondaryUserRoles(): UserRoles[] {
    return this._secondaryUserRoles;
  }

  resetSecondaryRoles() {
    this._secondaryUserRoles = [];
  }

  isPaymentOverrideDisabled() {
    const isManager = this.primaryUserRole === UserRoles.MANAGER;
    const isFinance = this.primaryUserRole === UserRoles.FINANCE;
    const isManagerOrFinanceInSecondaryRole = this._secondaryUserRoles.find(role => role === UserRoles.MANAGER || role === UserRoles.FINANCE);
    return Boolean(isManager || isFinance || isManagerOrFinanceInSecondaryRole);
  }

  checkForManagerRole(token: string, eventInformation?: MercuryEvents) {
    const managerEvents = JwtUtils.getEventsFromToken(token, "rxOnsiteManagerEe") || [];
    const foundEvent = managerEvents.find(event => event === eventInformation?.gbsCode);
    if (foundEvent) {
      this._secondaryUserRoles = Array.from(new Set([...this._secondaryUserRoles, UserRoles.MANAGER]));
    }
  }

  checkForFinanceRole(token: string, eventInformation?: MercuryEvents) {
    const financeEvents = JwtUtils.getEventsFromToken(token, "rxOnsiteFinanceEe") || [];
    const foundEvent = financeEvents.find(event => event === eventInformation?.gbsCode);
    if (foundEvent) {
      this._secondaryUserRoles = Array.from(new Set([...this._secondaryUserRoles, UserRoles.FINANCE]));
    }
  }

  async getUserRole() {
    const token = await authorizationStore.getToken();
    const currentEvent = localStorage.getItem(ODIN_EVENT_EDITION_STORAGE_KEY);
    const mercuryEventInfo = EventsHelper.mercuryEvents.find(event => event.atlasId === currentEvent);

    if (!token) {
      return this.primaryUserRole;
    }
    if (JwtUtils.isLoggedUserRxAdmin(token)) {
      this.primaryUserRole = UserRoles.RX_ADMIN;
      this.checkForManagerRole(token, mercuryEventInfo);
      this.checkForFinanceRole(token, mercuryEventInfo);
      return UserRoles.RX_ADMIN;
    }
    if (JwtUtils.isLoggedUserBUAdmin(token)) {
      this.primaryUserRole = UserRoles.BU_ADMIN;
      this.checkForManagerRole(token, mercuryEventInfo);
      this.checkForFinanceRole(token, mercuryEventInfo);
      return UserRoles.BU_ADMIN;
    }

    if (currentEvent) {
      const eventInformation = EventsHelper.mercuryEvents.find(event => event.atlasId === currentEvent);

      const managerEvents = JwtUtils.getEventsFromToken(token, "rxOnsiteManagerEe") || [];
      let foundEvent = managerEvents.find(event => event === eventInformation?.gbsCode);
      if (foundEvent) {
        this.primaryUserRole = UserRoles.MANAGER;
        return UserRoles.MANAGER;
      }

      const agentEvents = JwtUtils.getEventsFromToken(token, "rxOnsiteEe") || [];
      foundEvent = agentEvents.find(event => event === eventInformation?.gbsCode);
      if (foundEvent) {
        this.primaryUserRole = UserRoles.CUSTOMER_SERVICES_AGENT;
        return UserRoles.CUSTOMER_SERVICES_AGENT;
      }

      const financeEvents = JwtUtils.getEventsFromToken(token, "rxOnsiteFinanceEe") || [];
      foundEvent = financeEvents.find(event => event === eventInformation?.gbsCode);
      if (foundEvent) {
        this.primaryUserRole = UserRoles.FINANCE;
        return UserRoles.FINANCE;
      }
    }
    this.primaryUserRole = UserRoles.CUSTOMER_SERVICES_AGENT;
    return UserRoles.CUSTOMER_SERVICES_AGENT;
  }
}

export default new JWTHelper();
